import { GlobalConfig } from "config";

export const SDKConfig = {
  basePath: GlobalConfig.ENGINE_BASE_PATH,
  token: "",
};
